import { render, staticRenderFns } from "./PddRelationDialog.vue?vue&type=template&id=0d39ff2b&scoped=true"
import script from "./PddRelationDialog.vue?vue&type=script&lang=js"
export * from "./PddRelationDialog.vue?vue&type=script&lang=js"
import style0 from "./PddRelationDialog.vue?vue&type=style&index=0&id=0d39ff2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d39ff2b",
  null
  
)

export default component.exports